import { render, staticRenderFns } from "./AdditionalClosure.vue?vue&type=template&id=bd2bc108"
import script from "./AdditionalClosure.vue?vue&type=script&lang=js"
export * from "./AdditionalClosure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports